import { render, staticRenderFns } from "./StoriesPanel.vue?vue&type=template&id=05bd75d4&scoped=true&"
import script from "./StoriesPanel.vue?vue&type=script&lang=ts&"
export * from "./StoriesPanel.vue?vue&type=script&lang=ts&"
import style0 from "./StoriesPanel.vue?vue&type=style&index=0&id=05bd75d4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bd75d4",
  null
  
)

export default component.exports